import { Component, input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { FormValidationComponent } from '@pedix-workspace/angular-ui-form-reactive';
import { IconLoadingComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-shipping-calculation',
  templateUrl: './shipping-calculation.component.html',
  styleUrls: ['./shipping-calculation.component.scss'],
  imports: [
    TranslocoDirective,
    AlertComponent,
    FormValidationComponent,
    FormsModule,
    IconLoadingComponent,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ShippingCalculationComponent {
  readonly isFormSubmitted = input.required<boolean>();
}
